(() => {
  const storageKey = 'si.product-navigation.v1';
  const maxAge = 2 * 60 * 60 * 1000;
  const navigation = document.querySelector('[data-si-product-navigation]');
  const currentURL = new URL(window.location.href);
  const now = () => Date.now();

  function readState() {
    try {
      const state = JSON.parse(window.sessionStorage.getItem(storageKey));
      if (state && Array.isArray(state.entries)) {
        state.entries = state.entries.filter(entry => entry && typeof entry.handle === 'string' && typeof entry.url === 'string' && Number.isFinite(entry.at));
        return state;
      }
    } catch {}
    return { entries: [] };
  }

  function writeState(state) {
    try {
      window.sessionStorage.setItem(storageKey, JSON.stringify(state));
    } catch {}
  }

  function returnURL(value) {
    if (typeof value !== 'string' || value.length === 0) return null;
    try {
      const url = new URL(value, currentURL.origin);
      if (url.origin !== currentURL.origin || !/^https?:$/.test(url.protocol)) return null;
      if (/\/(?:admin|account|cart|checkout|checkouts|apps)(?:\/|$)/.test(url.pathname)) return null;
      if (/\/products\//.test(url.pathname)) return null;
      return url;
    } catch {
      return null;
    }
  }

  function productHandle(url) {
    const match = url.pathname.match(/\/products\/([^/]+)\/?$/);
    try {
      return match ? decodeURIComponent(match[1]) : null;
    } catch {
      return null;
    }
  }

  function rememberProduct(event) {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('a[href]');
    if (!link || link.closest('[data-si-product-navigation]') || link.hasAttribute('download')) return;
    if (typeof event.button === 'number' && event.button > 1) return;
    const source = returnURL(window.location.href);
    if (!source) return;
    let target;
    try {
      target = new URL(link.href, currentURL.origin);
    } catch {
      return;
    }
    if (target.origin !== currentURL.origin) return;
    const handle = productHandle(target);
    if (!handle) return;
    const state = readState();
    state.entries = state.entries.filter(entry => entry.handle !== handle && now() - entry.at < maxAge);
    state.entries.push({ handle, url: source.href, at: now(), y: window.scrollY });
    state.entries = state.entries.slice(-24);
    writeState(state);
  }

  document.addEventListener('pointerdown', rememberProduct, { capture: true, passive: true });
  document.addEventListener('click', rememberProduct, { capture: true, passive: true });

  const state = readState();
  const restore = state.restore;
  if (restore) {
    delete state.restore;
    writeState(state);
    const restoreURL = returnURL(restore.url);
    if (restoreURL && restoreURL.href === currentURL.href && now() - restore.at < 30000 && Number.isFinite(restore.y)) {
      const restoreScroll = () => {
        if (window.scrollY > 10) return;
        window.requestAnimationFrame(() => window.requestAnimationFrame(() => {
          window.scrollTo({ top: Math.max(0, restore.y), behavior: 'auto' });
        }));
      };
      if (document.readyState === 'complete') restoreScroll();
      else window.addEventListener('load', restoreScroll, { once: true });
    }
  }

  if (!navigation) return;
  const back = navigation.querySelector('[data-si-back]');
  const category = navigation.querySelector('[data-si-category]');
  if (!back || !category) return;
  const referrer = document.referrer ? returnURL(document.referrer) : null;
  const entry = state.entries.find(item => item.handle === navigation.dataset.productHandle && now() - item.at < maxAge);
  let source = null;
  let scrollY = 0;
  if (entry) {
    const savedURL = returnURL(entry.url);
    const hasAdParameters = [...currentURL.searchParams.keys()].some(key => /^(?:gclid|dclid|gbraid|wbraid|utm_)/i.test(key));
    const matchesReferrer = referrer && savedURL && referrer.pathname === savedURL.pathname;
    const recentWithoutReferrer = !document.referrer && now() - entry.at < 15000 && !hasAdParameters;
    if (savedURL && (matchesReferrer || recentWithoutReferrer)) {
      source = savedURL;
      scrollY = Number.isFinite(entry.y) ? entry.y : 0;
    }
  }
  if (!source && referrer) source = referrer;
  if (!source) return;

  back.href = source.href;
  let collections = [];
  try {
    collections = JSON.parse(navigation.dataset.productCollections || '[]');
  } catch {}
  const sourceCollection = collections.find(item => {
    const url = returnURL(item.url);
    return url && url.pathname === source.pathname;
  });
  if (sourceCollection) {
    category.href = sourceCollection.url;
    category.textContent = sourceCollection.title;
  } else {
    const allProducts = returnURL(navigation.dataset.allProductsUrl);
    if (allProducts && allProducts.pathname === source.pathname) {
      category.href = navigation.dataset.allProductsUrl;
      category.textContent = navigation.dataset.allProductsTitle;
    }
  }

  back.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const latestState = readState();
    latestState.restore = { url: source.href, at: now(), y: scrollY };
    writeState(latestState);
  });
})();
